import { render, staticRenderFns } from "./backend-receipt-list.vue?vue&type=template&id=84163424&scoped=true"
import script from "./backend-receipt-list.ts?vue&type=script&lang=ts&external"
export * from "./backend-receipt-list.ts?vue&type=script&lang=ts&external"
import style0 from "./backend-receipt-list.scoped.scss?vue&type=style&index=0&id=84163424&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84163424",
  null
  
)

export default component.exports